import { BuildingType } from "../types/castle";

// Per-element names for the Signature building. The shared catalog uses
// a generic "Сигнатурное здание"; the client overlays an element-themed
// name based on the player's faction.
const SignatureBuildingByElement: Record<number, string> = {
  0: "Пепельный алтарь",   // Fire — phoenix rises from ashes
  1: "Священное озеро",    // Water — where mermaids dwell
  2: "Чертог бурь",        // Air — storm druid hall
  3: "Каменный курган",    // Earth — burial mound, mithril titan rests within
};

export function buildingDisplayName(
  type: number,
  defaultName: string,
  playerElement: number | undefined,
): string {
  if (type === BuildingType.SignatureForge && playerElement != null) {
    return SignatureBuildingByElement[playerElement] ?? defaultName;
  }
  return defaultName;
}
